import { Spacing } from '@persona-id/design-tokens';
import { COLORS } from 'shared/styles/variables';
import styled from 'styled-components';

import { PoliticallyExposedPersonMatch } from 'dashboard/models/report/politically-exposed-person';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import { paragraphMixins } from 'design-system/mixins/text';
import theme from 'design-system/theme';
import IconChevron from 'images/icons/chevron.svg';

import { MatchIconAlert, MatchIconDismissed } from './MatchIcons';

const StyledIconChevron = styled(IconChevron)`
  width: ${Spacing[5]};
  flex-shrink: 0;
  align-self: center;
`;

const Container = styled.div`
  display: grid;
  grid-column-gap: ${Spacing[2]};
  grid-template-columns: ${Spacing[5]} 1fr ${Spacing[5]};
  padding: ${Spacing[2]} 0;
`;

const MatchSummaryContent = styled('div')`
  flex-grow: 1;
`;

const MatchTitle = styled('div')`
  ${paragraphMixins.lgBold};
  color: ${theme.color.text.primary};
  line-height: 26px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Subtext = styled('div')`
  ${paragraphMixins.md};
  display: flex;
  color: ${COLORS.gray70};
`;

const StyledSticker = styled(Sticker)`
  margin-left: 4px;
`;

const Stickers = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;

const PoliticallyExposedPersonEntityMatchSummary = ({
  entity,
  isDismissed,
  isReportHistoryElement,
}: {
  entity: PoliticallyExposedPersonMatch;
  isDismissed?: boolean;
  isReportHistoryElement?: boolean;
}) => {
  const { name, birthdates, locations } = entity;
  const subText = birthdates?.join(' • ');
  const isAssociate = entity['pep-type'] === 'associate';

  let icon;
  if (isDismissed) {
    icon = <MatchIconDismissed />;
  } else {
    icon = <MatchIconAlert />;
  }

  return (
    <Container>
      {icon}
      <MatchSummaryContent>
        <MatchTitle>
          {name ?? ''}
          {isAssociate && <StyledSticker variant='primary'>ASSOCIATE</StyledSticker>}
        </MatchTitle>
        {subText && (
          <>
            <Spacer height={1} />
            <Subtext>{subText}</Subtext>
          </>
        )}
        {!isReportHistoryElement && (
          <>
            <Spacer height={1} />
            <Stickers>
              {locations?.map((location) => (
                <StyledSticker key={location}>{location.toUpperCase()}</StyledSticker>
              ))}
            </Stickers>
          </>
        )}
      </MatchSummaryContent>
      {!isReportHistoryElement && <StyledIconChevron />}
    </Container>
  );
};

export default PoliticallyExposedPersonEntityMatchSummary;
